// src/pages/Dashboard/components/ChatPanel/ChatMessages.js
import React, { useEffect, useRef, useCallback } from 'react';
import ChatMessage from './ChatMessage';

const ChatMessages = ({ messages, isLoading, messagesEndRef }) => {
  const containerRef = useRef(null);
  const isScrolling = useRef(false);
  const scrollTimeout = useRef(null);

  // Smooth scroll to bottom com throttling
  const scrollToBottom = useCallback(() => {
    if (isScrolling.current) return;
    
    if (messagesEndRef?.current) {
      isScrolling.current = true;
      
      messagesEndRef.current.scrollIntoView({ 
        behavior: 'smooth',
        block: 'end'
      });
      
      // Reset flag after scroll completes
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
      
      scrollTimeout.current = setTimeout(() => {
        isScrolling.current = false;
      }, 100);
    }
  }, [messagesEndRef]);

  // Auto-scroll apenas quando há novas mensagens ou durante loading
  useEffect(() => {
    const shouldScroll = messages.length > 0 || isLoading;
    if (shouldScroll) {
      // Pequeno delay para permitir render antes do scroll
      requestAnimationFrame(() => {
        scrollToBottom();
      });
    }

    return () => {
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, [messages.length, isLoading, scrollToBottom]);

  if (messages.length === 0 && !isLoading) {
    return (
      <div className="chat-messages-dashboard" ref={containerRef}>
        <div className="empty-chat-dashboard">
          <p>Nenhuma mensagem ainda</p>
          <small>Comece uma conversa com o assistente jurídico</small>
        </div>
      </div>
    );
  }

  return (
    <div className="chat-messages-dashboard" ref={containerRef}>
      {messages.map((msg, index) => (
        <ChatMessage key={`${msg.role}-${index}-${msg.content?.substring(0, 20)}`} message={msg} />
      ))}
      
      {isLoading && (
        <div className="message-dashboard assistant">
          <div className="message-author-dashboard">Assistente Jurídico</div>
          <div className="loading-dots-dashboard">
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
      )}
      
      <div ref={messagesEndRef} style={{ height: '1px' }} />
    </div>
  );
};

export default ChatMessages;